/**
 * Форматирование денег и чисел для UI (ru-RU: пробел между разрядами, запятая в дробной части).
 */

const EMPTY = '—';

const intFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const moneyFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Парсит десятичную строку (поддержка запятой) в число.
 */
export function parseDecimalString(value: string | null | undefined): number | null {
  if (value == null || String(value).trim() === '') return null;
  const normalized = String(value).replace(/\s/g, '').replace(',', '.').trim();
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

/**
 * Целое с разделителями разрядов; null/undefined → «—».
 */
export function formatInteger(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return EMPTY;
  return intFormatter.format(value);
}

/**
 * Денежная сумма (2 знака после запятой); пусто / не число → «—».
 */
export function formatMoney(value: string | number | null | undefined): string {
  if (value === '' || value == null) return EMPTY;
  const num = typeof value === 'number' ? value : parseDecimalString(String(value));
  if (num === null) return EMPTY;
  return moneyFormatter.format(num);
}

/**
 * Число с дробной частью до 2 знаков без лишних нулей (для отображения не денег).
 */
export function formatDecimal(value: string | number | null | undefined): string {
  if (value === '' || value == null) return EMPTY;
  const num = typeof value === 'number' ? value : parseDecimalString(String(value));
  if (num === null) return EMPTY;
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
}
